import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';

type InitialUserLimitReachedModalType = {
  isOpen: boolean;
  onClose: () => void;
};

export const InitialUserLimitReachedModal = ({ isOpen, onClose }: InitialUserLimitReachedModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='504px'>
      <Box width='100%' display='flex' flexDirection='column' rowGap='28px'>
        <Box width='100%' display='flex' flexDirection='column' alignItems='center' rowGap='20px'>
          <WarningSecondaryIcon />
          <Box width='100%' display='flex' flexDirection='column' alignItems='center' rowGap='12px'>
            <Typography variant='headline4' color={COLORS.black} fontWeight='semibold'>
              Subscription Not Purchased
            </Typography>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              Only one invited, unconfirmed or active Master Admin can exist in the organization until a subscription is
              purchased.
            </Typography>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              To create a new Master Admin, please block the existing one first.
            </Typography>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              Alternatively, you may contact the current Master Admin and remind them to complete the subscription
              purchase.
            </Typography>
          </Box>
        </Box>
        <Button onClick={onClose}>Back</Button>
      </Box>
    </ModalWindow>
  );
};
